import { type CSSProperties, useMemo } from 'react';
import styled, { keyframes } from 'styled-components';

import SpinnerIcon from '@/assets/icons/SpinnerIcon';
import { CenterFlex } from '@/components/base';
import Transition from '@/components/Common/Transition';
import useColor from '@/hooks/domain/useColor';
import { animation } from '@/styles/style';

const Spinner = (props: {
  size?: number;
  style?: CSSProperties;
  status?: boolean;
  color?: string;
}) => {
  const color = useColor();
  const size = useMemo(() => {
    return props.size ? props.size : 16;
  }, [props.size]);

  return (
    <Transition
      status={typeof props.status === 'undefined' ? true : props.status}
      animations={{
        in: animation.fadeIn,
        out: animation.fadeOut,
      }}
      style={{
        width: size,
        height: size,
        color: props.color,
        overflow: 'hidden',
      }}
    >
      <IconWrapper>
        <SpinnerIcon
          fill={props.color || color.primary100}
          width={size}
          height={size}
          style={props.style}
        />
      </IconWrapper>
    </Transition>
  );
};

const rotateAnimation = keyframes`
 0% {
      transform: rotate(0deg);
    }
    80% {
      transform: rotate(360deg);
    }
    100% {
      transform: rotate(360deg);
    }
`;

const IconWrapper = styled(CenterFlex)`
  animation: ${rotateAnimation} ease 1000ms infinite;
`;

export default Spinner;
